import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Videos {
    static init() {
        const containers = document.querySelectorAll('.videolist__container');
        if (containers.length > 0) {
            containers.forEach((container) => {
                tns({
                    container: container,
                    items: 1,
                    slideBy: 1,
                    autoplay: false,
                    gutter: 30,
                    loop: false,
                    mouseDrag: true,
                    nav: false,
                    speed: 650,
                    controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g fill="none" stroke="#262626" stroke-width="3"><circle cx="27" cy="27" r="27" stroke="none"/><circle cx="27" cy="27" r="25.5" fill="none"/></g><g transform="translate(26.308 39.146) rotate(-135)"><path d="M18.154,0,0,18.154" transform="translate(0 0)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path d="M7.771,7.771H0V0" transform="translate(0 10.383)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g fill="none" stroke="#262626" stroke-width="3"><circle cx="27" cy="27" r="27" stroke="none"/><circle cx="27" cy="27" r="25.5" fill="none"/></g><g transform="translate(26.308 39.146) rotate(-135)"><path d="M18.154,0,0,18.154" transform="translate(0 0)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path d="M7.771,7.771H0V0" transform="translate(0 10.383)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></svg>'],
                    responsive: {
                        768: {
                            items: 2,
                        },
                        1024: {
                            items: 4,
                        }
                    }
                });
            });
        }
    }
}